import { FormControl, ValidatorFn } from '@angular/forms';

export const notEqualToValue =
  (compareValue: any): ValidatorFn =>
  (control: FormControl) => {
    const myValue = control.value;

    return myValue !== compareValue ? null : { valueEqualTo: compareValue };
  };
